import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Layout } from "antd";
import { useAuth } from "@/contexts";
import { ROUTES } from "@/consts";

const AuthLayout = () => {
	const {
		state: { token },
	} = useAuth();

	if (token) {
		return <Navigate to={ROUTES.home} />;
	}
	return (
		<Layout
			className="layout"
			style={{
				minHeight: "100vh",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Suspense fallback={<div>Loading...</div>}>
				<Outlet />
			</Suspense>
		</Layout>
	);
};

export default AuthLayout;
